// Actions
import { FilterTopActions, FilterTopActionTypes } from './filter-top.actions';

// Models
import { FilterTopState } from './filter-top.state';
import { ListType } from '../../../shared/models/b2b/filterTop';
import { SearchSettings } from '../../../shared/models/b2b/searchSettings';

const defaultState: FilterTopState = {
    currentListType: ListType.small,
    settings: new SearchSettings(),
};

export type Action = FilterTopActions;

export function FilterTopReducer(state = defaultState, action: any) {
    // console.log(state, action);
    switch (action.type) {
        case FilterTopActionTypes.DO_SET_LIST_TYPE:
            return {
                ...state,
                currentListType: action.payload.listType,
            };

        case FilterTopActionTypes.DO_SET_SETTINGS:
            return {
                ...state,
                settings: action.payload.settings,
            };

        default:
            return state;
    }
}
